import React from 'react'
import image4 from '../images/bfarsace_200803_4124_0016.webp'
import image3 from '../images/Google_Pixel_6_Pro__Alt_Angle_.webp'

const MidAlert = () => {
  return (
    <div className='w-full bg-gray-200 bg-opacity-60 py-10 mt-20'>
      <div className='m-auto'>
        <div className=''>
          <div className='flex flex-wrap justify-evenly bg-gray-200 items-center'>
            <div style={{ maxWidth: '370px' }} className='m-5 lg:order-1'>
              <h3 className='text-3xl font-bold'>Our Pick</h3>
              <p>
                Samsung never dissapoints when it comes to visual appeal and Display quality, the
                Samsung Galaxy Note 20 Ultra comes as one of the best phones of the year 2020. It
                comes in as one of the high end phones, but gives good value for money.
              </p>
              <button className='mt-8 animate-pulse bg-red-700 py-2 px-3 text-gray-100'>
                Shop Now
                <i className='fa fa-shopping-cart ml-2'></i>
              </button>
            </div>
            <div className='m-5 lg:order-2'>
              <img style={{ width: '400px', minWidth: '250px' }} src={image4} alt='mid-image' />
            </div>
          </div>

          <div className='flex flex-wrap justify-evenly items-center'>
            <div style={{ maxWidth: '370px' }} className='m-5 lg:order-4'>
              <h3 className='text-3xl font-bold'>Our Pick</h3>
              <p>
                The Google Pixel 6 Pro phone is on our pick list for good reason, it combines a
                sleek design with the powerful Snapdragon processor all in a beautiful package.
              </p>
              <button className='mt-8 animate-pulse bg-red-700 py-2 px-3 text-gray-100'>
                Shop Now
                <i className='fa fa-shopping-cart ml-2'></i>
              </button>
            </div>
            <div className='m-5 lg:order-3'>
              <img style={{ width: '400px', minWidth: '250px' }} src={image3} alt='mid-image' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MidAlert
